<template>
  <section class="bg-base-100 py-16">
    <div class="max-w-7xl mx-auto px-4">
      <div class="text-center mb-16">
        <h2 class="text-3xl font-bold text-base-content mb-4">Meet Our Team</h2>
        <p class="text-base-content/70 max-w-2xl mx-auto">
          The passionate people behind our success. We're a team of creators, thinkers, and problem solvers.
        </p>
      </div>
      
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
        <!-- Team Member Card -->
        <div 
          v-for="(member, index) in team" 
          :key="index"
          class="card bg-base-200 hover:-translate-y-2 transition-transform duration-300 shadow-xl"
        >
          <div class="card-body items-center text-center pt-8">
            <div class="avatar mb-4">
              <div class="w-32 rounded-full ring ring-primary ring-offset-base-100 ring-offset-2">
                <img :src="member.image" :alt="member.name" />
              </div>
            </div>
            <h3 class="card-title text-lg mb-1">{{ member.name }}</h3>
            <div class="text-primary font-medium text-sm mb-3">{{ member.role }}</div>
            <div class="flex items-center gap-2 text-base-content/70 hover:text-primary transition-colors mt-auto">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
              </svg>
              <a :href="`mailto:${member.email}`" class="text-sm">{{ member.email }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
const team = [
  {
    name: 'Sayem Khan',
    role: 'CEO & Founder',
    email: 'ceo@aanzamenu.com',
    image: 'https://i.pravatar.cc/300?img=11'
  },
  {
    name: 'Mutasim Billah',
    role: 'Chief Technology Officer',
    email: 'cto@aanzamenu.com',
    image: 'https://i.pravatar.cc/300?img=12'
  },
  {
    name: 'MD. Abdullah AL Fahad',
    role: 'Chief Financial Officer',
    email: 'cfo@aanzamenu.com',
    image: 'https://i.pravatar.cc/300?img=13'
  },
  {
    name: 'Nabil Mahmud Rifat',
    role: 'Chief Marketing Officer',
    email: 'cmo@aanzamenu.com',
    image: 'https://i.pravatar.cc/300?img=14'
  }
]
</script>
